import React from 'react';
import { 
  HeartIcon, 
  CodeBracketIcon,
  GlobeAltIcon,
  ShieldCheckIcon 
} from '@heroicons/react/24/outline';

const WorkflowFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-gray-200 px-4 py-2">
      <div className="max-w-full mx-auto">
        <div className="flex items-center justify-between text-xs text-gray-500">
          {/* Left side - Copyright */}
          <div className="flex items-center space-x-4">
            <span className="flex items-center">
              © {currentYear} Lightweight ITSM. All rights reserved.
            </span>
            <span className="hidden sm:flex items-center space-x-1">
              <span>Made with</span>
              <HeartIcon className="h-3 w-3 text-red-500 fill-current" />
              <span>by IT Team</span>
            </span>
          </div>

          {/* Center - Version/Environment */}
          <div className="hidden md:flex items-center space-x-4">
            <span className="flex items-center space-x-1">
              <CodeBracketIcon className="h-3 w-3" />
              <span>v1.0.0</span>
            </span>
            <span className="flex items-center space-x-1">
              <GlobeAltIcon className="h-3 w-3" />
              <span>{process.env.REACT_APP_ENVIRONMENT || 'Development'}</span>
            </span>
            <span className="flex items-center space-x-1">
              <ShieldCheckIcon className="h-3 w-3 text-green-500" />
              <span>Secure</span>
            </span>
          </div>

          {/* Right side - Links */}
          <div className="flex items-center space-x-4">
            <a 
              href="/help" 
              className="hover:text-primary-600 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Help
            </a>
            <span className="text-gray-300">|</span>
            <a 
              href="/docs" 
              className="hover:text-primary-600 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Docs
            </a>
            <span className="text-gray-300 hidden sm:inline">|</span>
            <a 
              href="/privacy" 
              className="hidden sm:inline hover:text-primary-600 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </a>
            <span className="text-gray-300 hidden sm:inline">|</span>
            <a 
              href="/terms" 
              className="hidden sm:inline hover:text-primary-600 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WorkflowFooter;